export default {
  getProductsHome(state) {
    return state.productsHome || [];
  }
};
